import RichTextBox from './richtextbox.vue';
export default RichTextBox;


// WEBPACK FOOTER //
// ./src/components/richtextbox/index.js